var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WebDataRocks',{key:_vm.key,ref:"myPivot",attrs:{"report":_vm.pivotConfig,"global":_vm.pivotGlobal,"toolbar":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }